export default __webpack_public_path__ + "static/anticorruption-practices-mobile-banner-7ab045f5bec6d2f0f558725dd04422ce.png";